import { useEnvironment } from '@wix/yoshi-flow-editor';
import React, { FC } from 'react';
import { Text } from 'wix-ui-tpa/cssVars';
import { classes, st } from './CourseBadge.st.css';

export const COURSE_BADGE_DATA_HOOK = 'agenda-item-course-badge';

export type CourseBadgeProps = {
  badgeText?: string;
  theme?: 'default' | 'onImage';
};

export const CourseBadge: FC<CourseBadgeProps> = ({
  badgeText,
  theme = 'default',
}) => {
  const { isMobile } = useEnvironment();

  if (!badgeText) {
    return null;
  }

  return (
    <div
      data-hook={COURSE_BADGE_DATA_HOOK}
      className={st(classes.root, { isMobile, onImage: theme === 'onImage' })}
    >
      <Text className={classes.badgeText}>{badgeText}</Text>
    </div>
  );
};
